var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-fluid"},[_c('div',{staticClass:"content"},[_c('NavigationVuetify',{attrs:{"items":_vm.items}}),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }